export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer'
    },
    {
      title: true,
      name: 'Sistemas',
      wrapper: {        
        element: '',      
        attributes: {}
      },
      class: ''
    },
    {
      name: 'Themis',
      url: '/sistemas/themis',
      icon: 'custon-icon themis-icon'
    },
    {
      name: 'Cppro',
      url: '/sistemas/cppro',
      icon: 'custon-icon cppro-icon'
    },
    {
      name: 'Planilha',
      url: '/spreadsheet',
      icon: 'custon-icon excel-icon'
    }
  ]
};



// WEBPACK FOOTER //
// ./src/_nav.js